import { progress, updateNotice } from "@/mocks/comicData";

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20of%20a%20young%20immortal%20doctor%20with%20jade%20green%20and%20cinnabar%20red%20tones%2C%20traditional%20Chinese%20medicine%20herbs%20floating%20in%20misty%20mountains%2C%20atmospheric%20and%20mysterious%20dark%20background%2C%20elegant%20artistic%20illustration%2C%20high%20detail&width=1600&height=900&seq=hero-bg-001&orientation=landscape"
          alt="天才医仙漫画水墨风格首图"
          title="天才医仙漫画免费追更"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>
      </div>

      <div className="relative mx-auto flex max-w-7xl flex-col items-center px-4 pb-16 pt-32 text-center md:px-6 md:pb-24 md:pt-44">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <span className="h-2 w-2 animate-pulse rounded-full bg-accent-400"></span>
          今日更新 · {updateNotice[0].no}《{updateNotice[0].title}》
        </span>

        <h1 className="font-heading text-4xl font-bold leading-tight text-background-50 md:text-6xl">
          天才医仙漫画
        </h1>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          最新章节免费追更，连载进度一眼便知。今天有没有更新、最新章节到哪里了，收藏后自动提醒，不用再到处找。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#chapters"
            className="whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-book-open-line mr-1.5"></i>开始阅读最新话
          </a>
          <a
            href="#follow"
            className="whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            <i className="ri-bookmark-line mr-1.5"></i>收藏自动追更
          </a>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { label: "累计话数", value: `${progress.totalChapters} 话` },
            { label: "连载至卷", value: `第 ${progress.currentVolume} 卷` },
            { label: "每周更新", value: "三更连载" },
            { label: "最新进度", value: "今日已更" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-50/20 bg-background-50/10 px-3 py-4 backdrop-blur"
            >
              <dt className="text-xs text-background-100/90">{s.label}</dt>
              <dd className="mt-1 font-heading text-lg font-bold text-background-50">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}